export default "__VITE_ASSET__BqCJIWAZ__"